import { render } from "./Inspire.component.html?vue&type=template&id=fe4b1a46&ts=true&external"
import script from "./Inspire.component.ts?vue&type=script&lang=ts&external"
export * from "./Inspire.component.ts?vue&type=script&lang=ts&external"

import "./Inspire.component.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__